import types from "store/actions/requestActions/types";
import { FETCH_STATUS } from "constants/index";

export const changeStatusRequest = (
  state = {
    data: {},
    status: FETCH_STATUS.NOT_LOADED,
    error: "",
  },
  action
) => {
  const { payload: { data, error } = {} } = action;
  switch (action.type) {
    case types.SAVE_REQUEST_STATUS_REQUEST:
      return {
        ...state,
        status: FETCH_STATUS.LOADING,
        error: null,
      };
    case types.SAVE_REQUEST_STATUS_SUCCESS:
      return {
        ...state,
        data: data,
        status: FETCH_STATUS.LOADED,
      };
    case types.SAVE_REQUEST_STATUS_FAILURE:
      return {
        ...state,
        status: FETCH_STATUS.FAILED,
        error,
      };
    default:
      return state;
  }
};
